module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/outer_link/banner1-15855010d31a870a74d86f172d6403e5.png";